import { IsInt, IsUUID, IsOptional, IsBoolean } from 'class-validator';

export class GetBellNotificationsDto {
  @IsUUID()
  @IsOptional()
  lastId?: string;

  @IsInt()
  @IsOptional()
  limit?: number;

  @IsBoolean()
  @IsOptional()
  isRead?: boolean;
}
